import React, { useState } from 'react';
import './Correo.css';

export default function Correo() {
  const [form, setForm] = useState({
    nombre: '',
    email: '',
    mensaje: ''
  });

  const [enviado, setEnviado] = useState(false);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const mailto = `mailto:marko.informes@gmail.com?subject=Contacto%20desde%20la%20web%20-%20${encodeURIComponent(form.nombre)}&body=${encodeURIComponent(
      `Nombre: ${form.nombre}\nCorreo: ${form.email}\n\nMensaje:\n${form.mensaje}`
    )}`;
    window.location.href = mailto;
    setEnviado(true);
  };

  return (
    <>
      <div className="correo-section">
        <div className="correo-container">
          <h1 className="correo-title">Contáctanos</h1>
          <p className="correo-subtitle">
            ¿Tienes dudas, sugerencias o necesitas comunicarte con nosotros? Completa el siguiente formulario y te responderemos a la brevedad.
          </p>
          <form className="correo-form" onSubmit={handleSubmit}>
            <div className="correo-form-group">
              <label htmlFor="nombre">Nombre</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={form.nombre}
                onChange={handleChange}
                required
                placeholder="Tu nombre"
              />
            </div>
            <div className="correo-form-group">
              <label htmlFor="email">Correo electrónico</label>
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder="tu@email.com"
              />
            </div>
            <div className="correo-form-group">
              <label htmlFor="mensaje">Mensaje</label>
              <textarea
                id="mensaje"
                name="mensaje"
                value={form.mensaje}
                onChange={handleChange}
                required
                placeholder="Escribe tu mensaje aquí..."
                rows={6}
              />
            </div>
            <button type="submit" className="correo-btn">Enviar mensaje</button>
            {enviado && (
              <div className="correo-exito">
                ¡Gracias por contactarnos! Se abrirá tu cliente de correo para enviar el mensaje.
              </div>
            )}
          </form>
        </div>
      </div>
    </>
  );
}
